import GenerateProfileForm from "./GenerateProfileForm";

export default GenerateProfileForm;
